<wlm-family-relations-selector
  [availableItems]="availableItems$ | async"
  [selectedItemIds]="selectedItemIds"
  [isReadOnly]="formControl.disabled"
  (valueChanges)="onValueChanges($event)"
></wlm-family-relations-selector>
